import React, { useState, useEffect, useCallback } from 'react';
import { Button, Container, Row, Col, ButtonGroup } from "react-bootstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';

import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import {
  userActions,
  planActions,
} from '../../actions';

import PageTitle from "../../components/common/PageTitle";

const NewUserList = () => {
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const history = useHistory();
  const dispatch = useDispatch();
  const loading = useSelector(state => state.user.loading);
  const error = useSelector(state => state.user.error);
  const users = useSelector(state => state.user.users);
  const currentPage = useSelector(state => state.user.page);
  const total = useSelector(state => state.user.total);
  const plans = useSelector(state => state.plan.plans);
  const [plansDetails, setPlansDetails] = useState({})
  const [usersList, setUsersList] = useState([])
  const [planFilter, setPlanFilter] = useState('')
  const [pageSize, setPageSize] = useState(10)
  const [searchTerm, setSearchTerm] = useState('')
  const displayedUsers = usersList;

  useEffect(() => {
    dispatch(planActions.getAll());
    dispatch(userActions.newDetails({ page: 1, limit: 10, search: '', planStatus: '' }));
  }, [dispatch]);

  useEffect(() => {
    let plansList = {}
    if (!_.isEmpty(plans)) {
      plans.forEach(plan => {
        plansList = {
          ...plansList,
          [plan._id]: {
            currency: plan.currency,
            intervalCount: plan.intervalCount,
            amount: plan.amount,
            interval: plan.interval
          }
        }
      })
      setPlansDetails(plansList);
    }
  }, [plans])

  const dateDiff = useCallback((date) => {
    if (!date) return '-';
    const today = new Date();
    const expDate = new Date(date);
    const diffTime = expDate - today;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }, []);

  useEffect(() => {

    if (users && Array.isArray(users)) {
      let usersLst = [];
      users.forEach(user => {
        let plan = '';
        const now = Date.now();
        const userSubscriptions = (user.subscriptions || [])
          .filter(subscription => subscription.status !== 'unpaid')
          .sort((first, second) => (
            Date.parse(second.currentPeriodEnd || 0) - Date.parse(first.currentPeriodEnd || 0)
          ));
        
        if (userSubscriptions && userSubscriptions.length > 0 && !_.isEmpty(plansDetails)) {
          const activeSubscription = userSubscriptions.find(subscription => (
            subscription.status === 'active'
            && Date.parse(subscription.currentPeriodEnd) > now
          ));
          const userSubscribe = activeSubscription || userSubscriptions[0];

          if (userSubscribe) {
            const planInterval = plansDetails[userSubscribe.plan];
            const exp = dateDiff(userSubscribe.currentPeriodEnd);
            const planName = planInterval
              ? `${planInterval.intervalCount} ${planInterval.interval}`
              : `Free`;
            const hasActivePlan = userSubscribe.status === 'active' && exp > 0;

            if (hasActivePlan && exp > 7) {
              plan = `Active, ${planName}, ${exp} days`;
            } else if (hasActivePlan) {
              plan = `NearExpiration, ${planName}, ${exp} days`;
            } else {
              const expirationText = exp <= 0
                ? `${Math.abs(exp)} days ago`
                : 'No active plan';
              plan = `Expired, ${planName}, ${expirationText}`;
            }
          } else {
            plan = '-';
          }
        } else {
          plan = '-';
        }
        const userDetail = {
          id: user._id,
          username: user.username,
          fullName: `${_.get(user, 'firstname', '-')} ${_.get(user, 'lastname', '-')}`,
          role: user.role,
          createdAt: user.createdAt ? user.createdAt.split('T')[0] : '-',
          plan: plan,
          designsCount: user.designsCount > 0 ? user.designsCount : 'No design',
        };
        usersLst.push(userDetail);
      });
      setUsersList(usersLst);
    }
  }, [users, plansDetails, dateDiff]);

  const columns = [
    {
      text: 'Username',
      dataField: 'username',
      formatter: usernameFormatter,
      searchable: true,
    },
    {
      text: 'Role',
      dataField: 'role',
      searchable: true,
    },
    {
      text: 'Plan',
      dataField: 'plan',
      formatter: planFormatter,
      sort: true,
      searchable: true,
    },
    {
      text: 'Designs',
      dataField: 'designsCount',
      sort: true,
    },
    {
      text: 'Registered',
      dataField: 'createdAt',
      formatter: dateFormatter,
      sort: true,
    },
    {
      text: 'Action',
      dataField: 'id',
      formatter: actionFormatter,
      csvExport: false,
    }
  ]

  function planFormatter(cell, row) {
    const plan = cell.split(',');
    switch (plan[0]) {
      case 'Expired':
        return (
          <p className="planStatus danger">
            <span className="planName">{plan[0]}</span><br />
            <span className="">{plan[1]} </span><span className="planDays"> ({plan[2]})</span>
          </p>
        )
      case 'NearExpiration':
        return (
          <p className="planStatus warning">
            <span className="planName">{plan[1]}</span><br /><span className="planDays">{plan[2]}</span>
          </p>
        )
      case 'Active':
        return (
          <p className="planStatus success">
            <span className="planName">{plan[1]}</span><br /><span className="planDays">{plan[2]}</span>
          </p>
        )
      default:
        return <span className="planStatus">-</span>;
    }
  }
  function dateFormatter(cell, row) {
    const date = cell.split('T')[0]
    return (
      date
    )
  }
  function usernameFormatter(cell, row) {
    return (
      <div className="tableTagBox">
        <span className="tableUsername">{cell}</span>
        <span className="tableName">{row.fullName}</span>
      </div>
    )
  }
  function actionFormatter(cell, row) {
    return (
      <div className="tableTempActionBox">
        <Button
          className="tableTempAction"
          variant="info"
          onClick={() => history.push(`/user/${cell}`)}
        >
          <i className="material-icons">info</i> Details
        </Button>
      </div>
    )
  }

  const handleSearch = useCallback((searchText) => {
    const normalizedSearch = searchText.trim();
    const effectiveSearch = normalizedSearch.length >= 3 ? normalizedSearch : '';

    setSearchTerm(normalizedSearch);
    dispatch(userActions.newDetails({
      page: 1,
      limit: pageSize,
      search: effectiveSearch,
      planStatus: planFilter
    }));
  }, [dispatch, pageSize, planFilter]);


  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === 'pagination') {
      setPageSize(sizePerPage);
      dispatch(userActions.newDetails({
        page: page,
        limit: sizePerPage,
        search: searchTerm.length >= 3 ? searchTerm : '',
        planStatus: planFilter
      }));
    } else if (type === 'search') {
      handleSearch(searchText);
    }
  };

  const paginationOptions = {
    page: currentPage || 1,
    sizePerPage: pageSize,
    totalSize: total,
    hidePageListOnlyOnePage: true,
    showTotal: true,
    paginationTotalRenderer: customTotal,
    sizePerPageList: [{
      text: '10', value: 10
    }, {
      text: '25', value: 25
    }, {
      text: '50', value: 50
    }]
  };

  const remote = {
    filter: false,
    pagination: true,
    sort: false,
    search: true,
    cellEdit: false
  };

  function customTotal(from, to, size) {
    return (
      <span className="react-bootstrap-table-pagination-total">
        Showing {from} to {to} of {size} Results
      </span>
    );
  }

  const filterBtnHandler = (filter) => {
    setPlanFilter(filter);
    dispatch(userActions.newDetails({
      page: 1,
      limit: pageSize,
      search: searchTerm.length >= 3 ? searchTerm : '',
      planStatus: filter
    }));
  }

  const retryUsers = () => {
    dispatch(userActions.newDetails({
      page: currentPage || 1,
      limit: pageSize,
      search: searchTerm.length >= 3 ? searchTerm : '',
      planStatus: planFilter
    }));
  };
  
  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title="Users List" subtitle="Users" className="text-sm-left" />
      </Row>
      <Row noGutters className="dateFilterRow">
        <Col >
          <span style={{ display: 'block', marginBottom: '-15px' }}>Plan Status:</span>
          <ButtonGroup className="mb-2">
            <Button disabled={loading} onClick={() => filterBtnHandler('')} className={planFilter === '' ? 'active' : ''}>All</Button>
            <Button disabled={loading} onClick={() => filterBtnHandler('active')} variant="success" className={planFilter === 'active' ? 'active' : ''}>Active</Button>
            <Button disabled={loading} onClick={() => filterBtnHandler('near')} variant="warning" className={planFilter === 'near' ? 'active' : ''}> Near Expire</Button>
            <Button disabled={loading} onClick={() => filterBtnHandler('expired')} variant="danger" className={planFilter === 'expired' ? 'active' : ''}>Expired / No Active Plan</Button>
          </ButtonGroup>
        </Col>
      </Row>

      <Row>
        <Col>
          {error && (
            <div className="alert alert-danger d-flex justify-content-between align-items-center" role="alert">
              <span>{error}</span>
              <Button variant="outline-danger" size="sm" onClick={retryUsers}>Retry</Button>
            </div>
          )}
          <ToolkitProvider
            keyField="id"
            data={displayedUsers}
            columns={columns}
            search={{
              searchFormatted: true,
              defaultSearch: '',
              placeholder: 'جستجوی کاربر (نام کاربری، نقش، پلن و ...)'
            }}
            exportCSV={{ fileName: 'Users.csv' }}
          >
            {
              props => (
                <div>
                  <div className="search-wrapper">
                    <SearchBar
                      {...props.searchProps}
                      placeholder="جستجو با نام کاربری، نام، نام خانوادگی یا نقش (حداقل ۳ حرف)"
                      delay={1500}
                      style={{
                        width: '100%',
                        padding: '10px',
                        marginBottom: '15px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                      }}
                    />
                  </div>
                  <ExportCSVButton {...props.csvProps}>Export CSV</ExportCSVButton>
                  <hr />
                  <BootstrapTable
                    {...props.baseProps}
                    remote={remote}
                    loading={loading}
                    pagination={paginationFactory(paginationOptions)}
                    onTableChange={handleTableChange}
                    noDataIndication={() => loading ? 'در حال بارگذاری...' : 'کاربری یافت نشد'}
                  />
                </div>
              )
            }
          </ToolkitProvider>
        </Col>
      </Row>
    </Container>
  );
}

export default NewUserList;
